// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: tHb3JUvnkKXjkrvzRvkdkE
// Component: PqHrVns2f7
import * as React from "react"
import { Link } from "gatsby"
import * as p from "@plasmicapp/react-web"
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
} from "@plasmicapp/react-web"
import { useScreenVariants as useScreenVariants_7WQHcNbMsC8 } from "./PlasmicGlobalVariant__Screen" // plasmic-import: 7wQHcNbMsC8/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css"
import * as projectcss from "./plasmic_stack_input_site.module.css" // plasmic-import: tHb3JUvnkKXjkrvzRvkdkE/projectcss
import * as sty from "./PlasmicResourcesTextBox.module.css" // plasmic-import: PqHrVns2f7/css
import _1PngWKXgaEo11 from "./images/_1Png.png" // plasmic-import: wKXgaEo11/picture

export const PlasmicResourcesTextBox__VariantProps = new Array()

export const PlasmicResourcesTextBox__ArgProps = new Array(
  "resourceLink",
  "textIn",
  "linkOut",
  "category",
  "image"
)

function PlasmicResourcesTextBox__RenderFunc(props) {
  const { variants, args, overrides, forNode } = props
  const $props = props.args
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariants_7WQHcNbMsC8(),
  })

  return (
    <p.PlasmicLink
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.a,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        sty.root
      )}
      component={Link}
      href={args.linkOut}
      platform={"gatsby"}
      target={"_blank"}
    >
      <div className={classNames(projectcss.all, sty.freeBox__l4Qft)}>
        <div className={classNames(projectcss.all, sty.freeBox__xCaA0)}>
          <p.PlasmicImg
            data-plasmic-name={"img"}
            data-plasmic-override={overrides.img}
            alt={""}
            className={classNames(sty.img)}
            displayHeight={"100%"}
            displayMaxHeight={
              hasVariant(globalVariants, "screen", "mobileOnly")
                ? "80px"
                : "80px"
            }
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"100%"}
            loading={"lazy"}
            src={
              args.image !== undefined
                ? args.image
                : {
                    src: _1PngWKXgaEo11,
                    fullWidth: 512,
                    fullHeight: 511,
                    aspectRatio: undefined,
                  }
            }
          />
        </div>

        <div className={classNames(projectcss.all, sty.freeBox__eLoO)}>
          <div className={classNames(projectcss.all, sty.freeBox__uVorp)}>
            <div className={classNames(projectcss.all, sty.freeBox__mgoys)}>
              {p.renderPlasmicSlot({
                defaultContents: "Loading resources!",
                value: args.textIn,
                className: classNames(sty.slotTargetTextIn),
              })}
            </div>

            <div className={classNames(projectcss.all, sty.freeBox__nl61I)}>
              <div className={classNames(projectcss.all, sty.freeBox__o1LZb)}>
                {p.renderPlasmicSlot({
                  defaultContents: "Categories :)",
                  value: args.category,
                  className: classNames(sty.slotTargetCategory),
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </p.PlasmicLink>
  )
}

const PlasmicDescendants = {
  root: ["root", "img"],
  img: ["img"],
}

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = deriveRenderOpts(props, {
      name: nodeName,
      descendantNames: [...PlasmicDescendants[nodeName]],
      internalArgPropNames: PlasmicResourcesTextBox__ArgProps,
      internalVariantPropNames: PlasmicResourcesTextBox__VariantProps,
    })

    return PlasmicResourcesTextBox__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    })
  }
  if (nodeName === "root") {
    func.displayName = "PlasmicResourcesTextBox"
  } else {
    func.displayName = `PlasmicResourcesTextBox.${nodeName}`
  }
  return func
}

export const PlasmicResourcesTextBox = Object.assign(
  // Top-level PlasmicResourcesTextBox renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    img: makeNodeComponent("img"),
    // Metadata about props expected for PlasmicResourcesTextBox
    internalVariantProps: PlasmicResourcesTextBox__VariantProps,
    internalArgProps: PlasmicResourcesTextBox__ArgProps,
  }
)

export default PlasmicResourcesTextBox
/* prettier-ignore-end */
